import { User } from "../admin/users/user/user";
import { Type } from "./Type";

export class TermsAndConditions{
    id:string;
    createDate:Date;
    content:string;
    createdBy:User;
    type:Type.submitApplication;
}